import { applyRailOrder } from "../lib/railOrder";
// Рельс не рисует синтезированные записи профиля (role:"profile") — их адрес живёт
// только в аватаре шапки (Design Decision 5).
export function railProductsFor(products, railOrder) {
    return applyRailOrder(products.filter((p) => !p.role), railOrder);
}
